class VimeoPlayer extends HTMLElement {
  constructor() {
    super();
    this.classList.add('vimeo-loading');
  }

  connectedCallback() {
    this.onLoad();
  }

  onLoad() {
    const videoContainer = this.querySelector('.iframe');

    if (videoContainer) {
      const video = new Vimeo.Player(videoContainer, {
        id: videoContainer.dataset.video,
        autoplay: true,
        loop: true,
        muted: false,
        responsive: true,
        background: true,
      });

      video.ready().then(() => {
        setTimeout(() => {
          this.classList.remove('vimeo-loading');
        }, 1000);
      }).catch(error => {
        console.error('Error loading Vimeo video:', error);
      });
    } else {
      console.log('No video container found');
    }
  }
}

customElements.define('vimeo-player', VimeoPlayer);
